import Hero from "@/components/home/Hero";
import About from "@/components/home/About";
import ExpertiseGrid from "@/components/home/ExpertiseGrid";
import ProjectsPreview from "@/components/home/ProjectsPreview";
import Story from "@/components/home/Story";
import Process from "@/components/home/Process";
import Heritage from "@/components/home/Heritage";
import WhyUs from "@/components/home/WhyUs";
import ContactBand from "@/components/home/ContactBand";
import SwooshDivider from "@/components/SwooshDivider";

export default function Home() {
  return (
    <>
      <Hero />
      <About />
      <SwooshDivider />
      <ExpertiseGrid />
      <SwooshDivider />
      <ProjectsPreview />
      <Story />
      <Process />
      <Heritage />
      <WhyUs />
      <ContactBand />
    </>
  );
}
